import { ModelResource } from './resource';
import { DeductionReason } from '../models';

export class DeductionReasons extends ModelResource<DeductionReason> {
  model = DeductionReason;

  resourcePath = 'v1/deductions/reason-codes';
}
